<template>
<div class="section nopad">
    <div class="_1200">
      <div class="breadcrumbs-box"><router-link to="/alternatives" class="breadcrumbs w-button">{{unit.name}}</router-link>
        <div class="yellow-slash-line"></div>
        <a href="#" class="breadcrumbs w-button">{{halufa.name}}</a>
        <a href="#" v-if="mine && editing && halufa._draft" v-on:click="finishEditing('publish')" title="שימו לב עד שהחלופה לא תפורסם היא לא תופיע באינדקס" v-tippy="{trigger:'mouseenter focus'}" class="action publish breadcrumbs w-button">פרסום חלופה</a>
          <a v-show="!editing" v-on:click="startEditing()" href="#" class="action breadcrumbs w-button"><span class="icon-font"> </span>עריכת חלופה</a>
          <a v-show="editing" v-on:click="finishEditing()" href="#" class="action breadcrumbs w-button"><span class="icon-font"> </span>שמירת שינויים</a>
          <a v-show="editing" v-on:click="deleteHalufa()" class="action breadcrumbs w-button"><span class="icon-font">  </span>מחיקת חלופה</a>
        </div>
      <div class="_790-under-line w-clearfix">
        <h2 v-if="!editing" class="sec-heading epi">{{halufa.name}}</h2>
        <input v-if="editing" class="sec-heading epi" style="width:100%;" placeholder="שם החלופה" v-model="halufa.name">
        <textarea style="display:block; margin-top:10px; width:100%;" v-if="editing" v-model="halufa.description" placeholder="תיאור החלופה"></textarea>
        <p v-if="!editing">{{halufa.description}}</p>
        <p class="blue-txt"><span class="icon-font yellow"> </span>מעלה החלופה: {{halufa.author}}</p>
        <div v-bind:class="mine?'mine':''" v-if="mine" class="move-to-left">
        </div>
      </div>
      <a v-if="editing" title="פרק הינה יחידת לימוד הכוללת מספר שיעורים" v-tippy='{ placement : "left" }' v-on:click="addChapter()" href="#" class="w-button">+ הוספת פרק חדש</a>
      <div class="chapter">
        
        <div v-for="(chapter, cIndex) in chapters" :key="cIndex" class="collection-list-art">
          <div class="epi-head-box">
            <a v-if="/*editing && mine && */chapter.lessons.length == 0"  href="#" @click="deleteChapter(cIndex)" class="edit-btn w-button delete"></a>
            <h3  v-if="!editing" class="epi-head">{{chapter.name}}</h3>
            <input class="epi-head" v-if="editing" placeholder="שם הפרק" v-model="chapter.name">
            <p v-if="!editing" class="white-box-gray-txt">{{chapter.sources}}</p>
            <input v-if="editing" class="white-box-gray-txt" placeholder="מקורות" v-model="chapter.sources" type="text">
          </div>
          <component :is="editing?'draggable':'div'" v-model="chapters[cIndex].lessons" class="collection-item-art-big">
            
              <router-link v-for="lesson in chapter.lessons" :key="lesson._id" :to="!editing?'/lesson/'+lesson._id:'#'" class="lesson white-box art-flex-big w-clearfix" v-on:click="goToLesson(lesson._id)">
                <div :style="lesson.backgroundImg?'background-image:url('+lesson.backgroundImg.url+')':''" class="art-thumbnail circal">
                </div>
                <div class="innerart-box">
                  <p class="white-box-head">{{lesson.name}}</p>
                  <p class="txt-box-57">{{lesson.description}}</p>
                  <p class="white-box-gray-txt">{{lesson.author}}</p>
                </div>
              </router-link>
          </component>
          <div class="bglBlock">
            <a v-if="editing"  title="תת יחידה המותאמת לשיעור אחד" v-tippy='{ placement : "left" }' v-on:click="addLesson(cIndex)" href="#" class="smaller w-button">+ הוספת שיעור חדש</a>
          </div>
        </div>
      </div>
      <div class="collection-list-wrapper"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from 'vuedraggable'

export default {
  name: 'alternatives',
  components: {
      draggable,
  },
  data(){
    return {
      moveAlong:'',
      halufa:{},
      chapters:[],
      mine:false,
      activeUnit:'',
      halufot:[],
      unit:{
        name:''
      },
      editing:false,
      staged:{
        chapter:{
          staging:false,
          name:'',
          sources:'',

        }
      }
    }
  },
  methods:{
      deleteChapter(i){
          db.doc('/collections/EjkRHWpS3klSkSMd3AzK/items/'+this.chapters[i].id).delete()
          this.$delete(this.chapters,i)
          db.doc('/collections/oVwbkKRU39ykpil2lw62/items/'+this.$route.params.id).update({
            chapters:this.chapters
          })
        },
      searchFunc(obj,child,term){
        var include={}
        $.each(obj,(i,e)=>{
          if (e[child].match(new RegExp(term, 'gi'))){
            include[i]=e;
          }
        });
        return include
      },
      addChapter(){
          this.chapters.unshift({
            name:'',
            sources:'',
            lessons:[]
          })
      },
      goToLesson(lessonId){
        console.log(lessonId)
        if (this.editing){
          this.moveAlong = '/lesson/'+lessonId+'?edit'
          this.finishEditing()
        }
      },
      addLesson(i){
        var info = {
          name:'',
          description:'',
          author: '',
          backgroundImg:{
            url:''
          },
          chapter:this.chapters[i].name,
          unit:this.unit.name,
          halufa:this.$route.params.id
        }
        db.collection('/collections/jhW3eoxQQnZJNqBCzm7S/items').add(info).then((doc)=>{
          info._id = doc.id
          this.chapters[i].lessons.push(info)
          this.moveAlong = '/lesson/'+doc.id+'?edit'
          this.finishEditing()
        })
    },
      uploadImage(index, li){
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      
      input.click();
      input.onchange = () => {
        var file = input.files[0]
      var storageRef = firebase.storage().ref(`${this.unit.name}/lessons/${file.name}`);
      var uploader = storageRef.put(file);
      uploader.on('state_changed', () => {}, (err) => {
        alert("error", err);
      }, () => {
        uploader.snapshot.ref.getDownloadURL().then((url) => {
        this.chapters[index].lessons[li].backgroundImg.url = url
        });
      });
      }
    },
      startEditing(){
      if (this.halufa._draft!= true || this.halufa._draft!= false){
        this.halufa._draft = true
      }
      this.editing = true
      var classSort = $('.collection-item-art-big')
      },
      updateHalufa(){
        db.doc('/collections/oVwbkKRU39ykpil2lw62/items/'+this.current).update(this.halufa).then(()=>{
          console.log('updated variation')
          if (this.moveAlong){
            this.$router.push(this.moveAlong)
          }
          this.halufa = ''
          this.chapters = []
          this.getItems()
        })
      },
      deleteHalufa(){
        if (confirm('בטוח למחוק?')) {
          db.doc('/collections/oVwbkKRU39ykpil2lw62/items/'+this.current).delete().then(()=>{
          var index = this.$parent.user.halufot.indexOf(this.$route.params.id)
            if (index > -1) {
                this.$parent.user.halufot.splice(index, 1);
           }
           var hlf = this.$parent.user.halufot
           db.doc('collections/nZSsggipwqsg74x8nJBu/items/'+this.$parent.user.uid).update({
             halufot:hlf
           }).then(()=>{
             this.$router.push('/alternatives')
           })
        })
          }
      },
      updateChapters(){
        var updater = 0
        $.each(this.chapters,(i,chapter)=>{
            $.each(chapter.lessons,(i,e)=>{
              chapter.lessons[i] = chapter.lessons[i]._id
            })
          if (chapter.id){
            var id = chapter.id
            delete chapter.id
            db.doc('/collections/EjkRHWpS3klSkSMd3AzK/items/'+id).update(chapter).then(()=>{
              console.log('chapter updated sucessfully')
              updater++
              if (updater == this.chapters.length){this.updateHalufa()}
            })
          } else {
            db.collection('/collections/EjkRHWpS3klSkSMd3AzK/items/').add(chapter).then((doc)=>{
              if (!this.halufa.chapters){this.halufa.chapters = []}
              this.halufa.chapters.push(doc.id)
              console.log('chapter added sucessfully '+doc.id)
              updater++
              if (updater == this.chapters.length){this.updateHalufa()}
            })
          }
        })
      },
      finishEditing(draft){
        if (draft){
          this.halufa._draft = false;
        }
        this.editing = false
        var totalSum = 0
        var updated = 0
        $.each(this.chapters,(i,chapter)=>{
          totalSum += chapter.lessons.length
          $.each(chapter.lessons,(n,lesson)=>{
            if (lesson._id){
              db.doc('/collections/jhW3eoxQQnZJNqBCzm7S/items/'+lesson._id).update(lesson).then(()=>{
                console.log('updated lesson successfully')
                updated++
                if (updated==totalSum){
                  this.updateChapters()
                  }
              })
            } else {
              db.collection('/collections/jhW3eoxQQnZJNqBCzm7S/items/').add(lesson).then((doc)=>{
                console.log(chapter)
                console.log('added new Lesson')
                lesson._id = doc.id
                updated++
                if (updated==totalSum){this.updateChapters()}
              })
            }
          })
        })
    },
    handleInput(e,item) {
      console.log(e.target.innerText)
      item = e.target.innerText
      this.$emit('input', this.content)
    },
    getItems(){
      db.doc('/collections/oVwbkKRU39ykpil2lw62/items/'+this.current).get().then((doc)=>{
        this.halufa = doc.data()
        db.doc("/collections/08KvFNfzvqAhTx1EQYUM/items/"+this.halufa.unit).get().then((unit)=>{
          this.unit = unit.data()
        })
        this.halufa.chapters.forEach((perek)=>{
          db.doc('/collections/EjkRHWpS3klSkSMd3AzK/items/'+perek).get().then((query)=>{
            var data = query.data()
            data.id = query.id
            this.chapters.push(data)
            var index = this.chapters.length-1
            var lessons = query.data().lessons
            this.chapters[index].lessons = []
            $.each(lessons,(i,lesson)=>{
              db.doc('/collections/jhW3eoxQQnZJNqBCzm7S/items/'+lesson).get().then((less)=>{
                var data = less.data()
                data._id = less.id
                console.log(data)
                this.chapters[index].lessons.push(data)
              })
            })
          })
        })
      })
    }
    },
    created(){
      this.current = this.$route.params.id
      console.log(this.$parent.user)
      if (this.$parent.user){
        if (this.$parent.user.halufot.includes(this.current)){
            this.mine = true
             if (window.location.search == '?edit'){
               this.startEditing()
          }
      }
      }
      this.getItems()
      },
      computed:{
        busFilter(){
          if (!this.search){
            return(this.businesses);
          } else {
            //var term = new RegExp(this.selectedUI.search, 'gi')
            //return this.categories.filter((e)=>{e.name.match(term)})
            return this.searchFunc(this.businesses,"businessName",this.search);
          }
        }
      },
      watch:{
        activeUnit(){
            this.halufot = []
            this.getHalufa()
        }
      }
}
</script>


<style scoped>
input,textarea {
  border: none;
  border-bottom:2px dashed #ffbd00;
}
.epi-head-box{
  position: relative;
  padding-right: 40px;
  margin-right: -40px;
}
.edit-btn.delete{
    position: absolute;
    top: 14px;
    right: -20px;
    display: none;
}
.epi-head-box:hover .edit-btn.delete{
    display: block;
}

.move-to-left{
  margin-top: 60px;
  margin-bottom: -60px;
}
.action {
    float: left;
    border:1px solid #3898EC;
    color: black;
    padding-right:20px;
    padding-left:20px;
    margin-left:10px;
    background: transparent;
    line-height: 20px;
}
.publish{
  border:1px solid #ffbd00;
    background: #ffbd00;
    padding-top:7px;
}
.action:hover{
  border:1px solid #3898EC;
    background: #3898EC;
    color: white;
}
.bglBlock{
  width:100%;
  margin-bottom: 40px;
}
.add-new.smaller.w-button{
  border:none;
  background: #3898EC;
  color:white;
}
.section.nopad {
    min-height: 84vh;
}
[contenteditable="true"]:focus{
	border-bottom: 2px solid blue;
}
[contenteditable]:empty:before{
		content:attr(placeholder);
}
[contenteditable="true"]{
	  display: block;
    width: 100%;
    border-bottom: 1px dashed #cccccc;
    outline: none;
}
[contenteditable="true"]:focus{
    border-color: #ffbd00;
}
</style>